import React, { useContext } from 'react';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import { featureEnabled } from 'utils';
import {
  FlexColumn,
  Section,
  SectionTitle,
  SubscriptionSectionHeader,
} from '../styles';
import AnsweringService from './AnsweringService';
import SupraSystem from './SupraSystem';
import LoadingSkeleton from './LoadingSkeleton';
import MLSUserPageContext from '../MLSUserPageContext';
import SubscriptionHistoryModal from './SubscriptionHistoryModal';

type SubscriptionsSectionProps = {};

const SubscriptionsSection: React.FC<SubscriptionsSectionProps> = () => {
  const { user, loading } = useContext(MLSUserPageContext);

  return (
    <>
      <Section data-cy={'supra-subscription-section'}>
        <SubscriptionSectionHeader>
          <SectionTitle>Subscriptions</SectionTitle>
          {(!featureEnabled('supraAutoCoopFeature') ||
            user?.coopType === SupraCoopType.PRIMARY) && (
            <SubscriptionHistoryModal />
          )}
        </SubscriptionSectionHeader>
        <FlexColumn addMargin>
          {loading ? (
            <LoadingSkeleton />
          ) : (
            <SupraSystem coopType={user?.coopType} />
          )}
        </FlexColumn>
        {(!featureEnabled('supraAutoCoopFeature') ||
          user?.coopType === SupraCoopType.PRIMARY) && (
          <FlexColumn addMargin>
            {loading ? <LoadingSkeleton /> : <AnsweringService />}
          </FlexColumn>
        )}
      </Section>
    </>
  );
};

export default SubscriptionsSection;
